module.exports = __webpack_public_path__ + "img/mzf.6ea0a7d6.png";